export const contactFormTrackingIDs = {
    business: {
        id: 'dagligbank-kontakt-form-business',
    },
    private: {
        id: 'dagligbank-kontakt-form-private',
    },
};
